import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Icon } from '../../Atoms/Icon'

type NavItem = {
  title: string
  href: string
}

type Props = {
  nextArticle?: NavItem
  showScrollToTop?: boolean
}

const ArticleFooter = ({ nextArticle, showScrollToTop = true }: Props) => {
  const scrollToTop = () => {
    document.getElementById('guide-layout')?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="flex items-center justify-between w-full h-20 text-primary">
      <div aria-hidden="true" />

      <div>
        {showScrollToTop && (
          <button
            type="button"
            className="my-4 inline-flex size-9 items-center justify-center rounded-full bg-primary text-primary-foreground transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary/90 active:translate-y-0 bg-rexBlue"
            onClick={scrollToTop}
            aria-label="Scroll to top"
          >
            <Icon iconName="AccordionArrowUp" colour="white" size="small" />
          </button>
        )}
      </div>

      <div>
        {nextArticle && (
          <Link
            to={nextArticle.href}
            className="inline-flex items-center justify-center gap-2 px-3 py-2 leading-none no-underline transition-colors duration-200 rounded-md group text-primary hover:bg-primary/10"
          >
            {nextArticle.title}
            <ChevronRight
              className="size-4 transition-transform duration-200 group-hover:translate-x-1.5"
              aria-hidden="true"
            />
          </Link>
        )}
      </div>
    </footer>
  )
}

export default ArticleFooter
